import type { RouteObject } from "react-router";
import { redirect } from "react-router";

/* Legacy routes redirected to new locations */
export const projectRedirects = [
  {
    path: "datasets/:datasetId/data-objects/:dataObjectId/material-history",
    loader: ({ params }) =>
      redirect(
        `/projects/${params.projectId}/data/material-histories/${params.dataObjectId}`,
      ),
  },
  {
    path: "datasets/:datasetId/data-objects/:dataObjectId/*",
    loader: ({ params }) =>
      redirect(
        `/projects/${params.projectId}/data/materials/${params.dataObjectId}`,
      ),
  },
  {
    path: "data-sources/*",
    loader: ({ request }) =>
      redirect(request.url.replace("/data-sources/", "/data/")),
  },
  {
    path: "material-histories/*",
    loader: ({ request }) =>
      redirect(
        request.url.replace(
          "/material-histories/",
          "/data/material-histories/",
        ),
      ),
  },
  {
    path: "models/*",
    loader: ({ request }) =>
      redirect(request.url.replace("/models/", "/predictors/")),
  },
  {
    path: "process-flows/*",
    loader: ({ request }) =>
      redirect(
        request.url.replace("/process-flows/", "/data/material-histories/"),
      ),
  },
  {
    path: "search-scopes/*",
    loader: ({ request }) =>
      redirect(request.url.replace("/search-scopes/", "/search-spaces/")),
  },
] as const satisfies RouteObject[];
